import * as React from "react";

export const ActivityTag = ({
    nameOfActivity,
    activityIconSrc,
    className
}: {
    nameOfActivity: string;
    activityIconSrc: string;
    className?: string;
}) => {
    return (
        <div
            className={`inline-flex justify-start rounded-xl bg-black bg-opacity-30 px-3 py-1 ${className}`}
        >
            <img
                src={activityIconSrc}
                className="h-4 pr-2.5"
                alt=""
                loading="lazy"
            />
            <p className="text-xs font-bold text-white">{nameOfActivity}</p>
        </div>
    );
};
